import { bunja } from 'bunja';
import { atom } from 'jotai';

import { isTradFiInstrument } from '@flipster/features/src/shared/rwa';
import { rawInstrumentsKeyBySymbolAtom } from '@flipster/features/src/shared/snapshot/state';
import { getLocalStorageAtom } from '@flipster/react/misc/state/use-local-storage';
import { PathnameScope } from '@flipster/react/providers/route';
import { JotaiStoreScope } from '@flipster/utils/bunja-jotai';
import { removeLocalePathname } from '@flipster/utils/pathname';

export const tradFiBannerBunja = bunja(() => {
  const store = bunja.use(JotaiStoreScope);
  const pathname = bunja.use(PathnameScope);

  const withoutLocalePathname = removeLocalePathname(pathname);
  const tradeSymbol = withoutLocalePathname.startsWith('/trade') ? (withoutLocalePathname.split('/')[3] ?? null) : null;

  const mountedAtom = atom(false);
  bunja.effect(() => store.set(mountedAtom, true));

  const isTradFiTradePageAtom = atom((get) => {
    if (!tradeSymbol) return false;
    // SSR 맥락에서 rawInstrumentsKeyBySymbolAtom이 prefetch 되기 전에 접근되는 것을 방지함
    if (!get(mountedAtom)) return false;
    const instrumentsKeyBySymbol = get(rawInstrumentsKeyBySymbolAtom);
    if (!instrumentsKeyBySymbol) return false;
    return isTradFiInstrument(instrumentsKeyBySymbol[tradeSymbol]);
  });

  const isTradFiBannerDismissedAtom = getLocalStorageAtom('flipster.configs.v1.dismissTradFiBanner', false);

  const dismissTradFiBanner = () => {
    store.set(isTradFiBannerDismissedAtom, true);
  };

  return { isTradFiTradePageAtom, isTradFiBannerDismissedAtom, dismissTradFiBanner };
});
